'use strict';
angular.module('autoremind.directives')
    .directive('printableIframe', ['printService',
    function (printService) {
        return {
            restrict: 'A',
            scope: {
                //printableContent: '=', // Attribute prefixed with 'printable' to make it clear that it belongs to this directive
                printableIframe: '='
            },
            link: function (scope, element, attrs) {
                scope.$watch('printableIframe', function (response) {
                    if (scope.printableIframe) {
                        // Set html content to be rendered as html (e.g. email message)
                        element.contents().find('html').html(scope.printableIframe);
                        printService.activeScope = scope;
                    }
                });
                scope.print = function () {
                    //element.print();
                    var frame = (element.context.contentWindow || element.context.contentDocument);
                    try {
                        frame.focus();
                        frame.print();
                    }
                    catch (err) {
                        console.log(err.message + '. Frame is ' + frame);
                    }
                };
            }
        };
    }]);
//# sourceMappingURL=printable-iframe.directive.js.map